// extracted by mini-css-extract-plugin
export default {"orgLink":"OrgLink-module__orgLink--mWbZQ"};